import { render } from "./InternalDocuments.vue?vue&type=template&id=7c180f2f"
import script from "./InternalDocuments.vue?vue&type=script&lang=js"
export * from "./InternalDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/InternalDocuments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c180f2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c180f2f', __exports__)) {
    console.log('reload')
    api.reload('7c180f2f', __exports__)
  }
  
  module.hot.accept("./InternalDocuments.vue?vue&type=template&id=7c180f2f", () => {
    console.log('re-render')
    api.rerender('7c180f2f', render)
  })

}


export default __exports__